import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowRight } from '../../../components';
import { Link } from './HeaderTabLink.styles';
export function HeaderTabLink({ url, text, ariaLabel, onClick, tabIndex }) {
    return (_jsxs(Link, Object.assign({ href: url, "aria-label": ariaLabel, onClick: onClick, tabIndex: tabIndex }, { children: [text, _jsx(ArrowRight, { color: "B300" }, void 0)] }), void 0));
}
//# sourceMappingURL=HeaderTabLink.js.map